<template>
    <div class="main">
        <c-panel title="COMPETÊNCIAS E HABILIDADES" titleIcon="fas fa-lightbulb">

            <el-row class="u-mt-10 u-mb-20" :gutter="10">
                <el-col :xs="24" :sm="8" :md="9">
                    <el-input v-model="filtro.descricao" placeholder="Pesquisar descrição..." @keyup.native.enter="load"></el-input>
                </el-col>
                <el-col :xs="12" :sm="5" :md="4">
                    <el-select v-model="filtro.tipo" clearable placeholder="Todos os tipos" style="width: 100%;" @change="load">
                        <el-option v-for="t in tipos" :key="t.valor" :label="t.label" :value="t.valor"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="12" :sm="5" :md="4">
                    <el-select v-model="visao" style="width: 100%;" @change="onTrocarVisao">
                        <el-option value="lista" label="Ver em lista"></el-option>
                        <el-option value="arvore" label="Ver em árvore"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="6" :md="7" class="u-text-right">
                    <router-link to="/admin/objetivo-aprendizagem/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVO REGISTRO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <!-- VISÃO EM LISTA -->
            <div class="container-table" v-if="visao === 'lista'">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th class="hidden-mobile" style="width: 70px;">cod</th>
                            <th class="hidden-mobile" style="width: 130px;">Tipo</th>
                            <th class="hidden-mobile" style="width: 110px;">Código</th>
                            <th>Descrição</th>
                            <th class="hidden-mobile">Vinculado a</th>
                            <th class="hidden-mobile u-text-center" style="width: 110px; text-transform: uppercase;">Situação</th>
                            <th style="width: 150px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="item in items" :key="item.id">
                            <td class="hidden-mobile">{{ item.id }}</td>
                            <td class="hidden-mobile">{{ rotuloTipo(item.tipo) }}</td>
                            <td class="hidden-mobile">{{ item.codigo }}</td>
                            <td>{{ item.descricao | truncate(70, '...') }}</td>
                            <td class="hidden-mobile">{{ item.pai ? item.pai.descricao : (item.grupo_conteudo ? item.grupo_conteudo.nome : '') | truncate(40, '...') }}</td>
                            <td class="hidden-mobile u-text-center" style="text-transform: uppercase;">{{ item.situacao === false ? 'Inativo' : 'Ativo' }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/objetivo-aprendizagem/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button @click="excluir(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="7" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum registro encontrado.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusList" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>

                <el-row :gutter="10" v-if="statusList">
                    <el-col :xs="24" :sm="12" :md="12">
                        <div class="u-text-left u-mt-10">
                            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                        <div class="u-text-right">
                            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                @current-change="getPage" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- VISÃO EM ÁRVORE -->
            <div class="container-table" v-else>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Hierarquia</th>
                            <th class="hidden-mobile" style="width: 130px;">Tipo</th>
                            <th class="hidden-mobile" style="width: 110px;">Código</th>
                            <th style="width: 150px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusArvore">
                        <tr v-for="linha in linhasArvore" :key="linha.id">
                            <td>
                                <span :style="{ 'padding-left': (linha.nivel * 24) + 'px' }"></span>
                                <i v-if="linha.nivel > 0" class="el-icon-right" style="color: #909399; margin-right: 6px;"></i>
                                {{ linha.descricao }}
                            </td>
                            <td class="hidden-mobile">{{ rotuloTipo(linha.tipo) }}</td>
                            <td class="hidden-mobile">{{ linha.codigo }}</td>
                            <td class="u-text-center acao">
                                <router-link :to="'/admin/objetivo-aprendizagem/edit/' + linha.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button @click="excluir(linha.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!linhasArvore.length">
                            <td colspan="4" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum registro encontrado.</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="!statusArvore" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>

        </c-panel>
    </div>
</template>

<script>
export default {
    data: () => ({
        visao: 'lista',
        statusList: false,
        statusArvore: false,
        filtro: { descricao: '', tipo: '' },
        paginate: { page: 1, qtdItens: null, from: '', to: '' },
        items: [],
        linhasArvore: [],
        tipos: [
            { valor: 'competencia', label: 'Competência' },
            { valor: 'conteudo', label: 'Conteúdo' },
            { valor: 'habilidade', label: 'Habilidade' },
            { valor: 'capacidade', label: 'Capacidade' },
            { valor: 'atitude', label: 'Atitude' }
        ]
    }),
    mounted () { this.load() },
    methods: {
        rotuloTipo (valor) {
            const t = this.tipos.find(x => x.valor === valor)
            return t ? t.label : valor
        },
        onTrocarVisao () {
            if (this.visao === 'arvore') this.loadArvore()
            else this.load()
        },
        load () {
            if (this.visao === 'arvore') { this.loadArvore(); return }
            this.statusList = false
            this.items = []
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/objetivo-aprendizagem/getAllPaginate?page=${this.paginate.page}`,
                this.filtro,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.items = r.data.data
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        loadArvore () {
            this.statusArvore = false
            this.linhasArvore = []
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/objetivo-aprendizagem/getArvore`,
                this.filtro,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.linhasArvore = this.achatar(Array.isArray(r.data) ? r.data : [], 0)
                this.statusArvore = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        /** A hierarquia vem montada do backend; aqui só achatamos para renderizar indentado. */
        achatar (nos, nivel) {
            let linhas = []
            nos.forEach(no => {
                linhas.push({ id: no.id, descricao: no.descricao, tipo: no.tipo, codigo: no.codigo, nivel: nivel })
                if (no.filhos && no.filhos.length) {
                    linhas = linhas.concat(this.achatar(no.filhos, nivel + 1))
                }
            })
            return linhas
        },
        recarregar () {
            if (this.visao === 'arvore') this.loadArvore()
            else this.load()
        },
        excluir (id) {
            this.$msgbox.confirm('Tem certeza que deseja excluir este registro?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => this.enviarExclusao(id, false)).catch(() => {})
        },
        /**
         * O service recusa a exclusão quando há itens vinculados e devolve a mensagem
         * com a contagem. A confirmação extra é pedida com o texto do próprio backend —
         * a tela não conhece nem recalcula essa regra.
         */
        enviarExclusao (id, confirmar) {
            window.eventBus.$emit('loading', true)
            const url = `${this.$store.state.config.baseUrlApi}/api/objetivo-aprendizagem/delete/${id}` + (confirmar ? '?confirmar=1' : '')
            this.$axios.delete(url, this.$store.getters.getHeaderAuth).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) {
                    const msg = typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text
                    if (!confirmar) {
                        this.$msgbox.confirm(msg, 'Atenção', { confirmButtonText: 'Excluir mesmo assim', cancelButtonText: 'Cancelar', type: 'warning' })
                            .then(() => this.enviarExclusao(id, true)).catch(() => {})
                        return
                    }
                    window.eventBus.$emit('alert', { msg: msg, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Excluído com sucesso.', type: 'success' })
                this.recarregar()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        getPage (page) {
            this.paginate.page = page
            this.load()
        }
    }
}
</script>
